import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { run } from "./labels";

const oggi = () => new Date().toISOString().slice(0, 10);

export const NuovoSalDialog = ({ kid, rettifica, emessi, onClose, onSaved }) => {
  const [f, setF] = useState({ periodo_da: "", periodo_a: oggi(), note: "", rif_sal_id: emessi[0]?.id || "" });
  const set = (k) => (e) => setF((o) => ({ ...o, [k]: e.target.value }));
  const crea = async () => {
    const body = { tipo_doc: rettifica ? "RETTIFICA" : "SAL", periodo_da: f.periodo_da || null, periodo_a: f.periodo_a, note: f.note || null,
      rif_sal_id: rettifica ? f.rif_sal_id : null };
    const r = await run(() => api.post(`/sal-contratti/${kid}/sal`, body), rettifica ? "Documento di rettifica creato in bozza" : "SAL creato in bozza");
    if (r) onSaved(r.data);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="nuovo-sal-dialog">
        <DialogHeader>
          <DialogTitle>{rettifica ? "Documento di rettifica" : "Nuovo SAL"}</DialogTitle>
          <DialogDescription>{rettifica ? "Corregge un SAL emesso senza modificarlo: le rettifiche si aggiungono nella bozza." : "Il SAL include le quantità verificate registrate fino alla data di fine periodo e non ancora contabilizzate. Nasce in bozza: nulla viene emesso senza conferma dell'amministratore."}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {rettifica && <div className="col-span-2 space-y-1"><Label className="text-xs">SAL da rettificare</Label>
            <select className="w-full border rounded-md h-9 px-2 text-sm" value={f.rif_sal_id} onChange={set("rif_sal_id")} data-testid="nuovo-sal-rif">
              {emessi.map((x) => <option key={x.id} value={x.id}>{x.etichetta} ({x.periodo_a})</option>)}</select></div>}
          <div className="space-y-1"><Label className="text-xs">Inizio periodo</Label><Input type="date" value={f.periodo_da} onChange={set("periodo_da")} data-testid="nuovo-sal-da" /></div>
          <div className="space-y-1"><Label className="text-xs">Fine periodo</Label><Input type="date" value={f.periodo_a} onChange={set("periodo_a")} data-testid="nuovo-sal-a" /></div>
          <div className="col-span-2 space-y-1"><Label className="text-xs">Note</Label><Input value={f.note} onChange={set("note")} data-testid="nuovo-sal-note" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="nuovo-sal-annulla">Annulla</Button>
          <Button onClick={crea} disabled={!f.periodo_a || (rettifica && !f.rif_sal_id)} data-testid="nuovo-sal-crea">Crea bozza</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
